module.exports = __webpack_public_path__ + "img/icon-court.a3110870.svg";